module.exports = __webpack_public_path__ + "ch-play.e8d7326.png";